import { Modal } from "antd"
import { AiFillWarning } from "react-icons/ai";
import { useSelector } from 'react-redux';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

export const SessionTimeoutError = ({ navigate }) => {

    const { isSessionExpired } = useSelector(state => state.dashboard)
    const { token } = useSelector(state => state.auth)

    if (!token) {
      navigate("../login")
    }

    return (
        <Modal title={
          <Flex alignItems={"flex-end"}>
            <AiFillWarning color="red" fontSize={"26px"} style={{ marginRight: "8px" }} />
            Session expired
          </Flex>
        } footer={null} open={isSessionExpired} closable={false} maskClosable={false} centered>
          <Text fontWeight='bolder' fontSize='small'>
            The session has timed out, please refresh screen to access it.
          </Text>
        </Modal>
      )
}